
/*eslint-disable*/
import React from "react";
// react library for routing
import { Link } from "react-router-dom";
// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Container,
  CardHeader,
  Row,
  Col,
  FormGroup,
  Input,
  Form,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Media,
  CardImg,
  Badge,
} from "reactstrap";
// core components
import { IndexNavbar } from "components/Navbars/IndexNavbar.jsx";
// import IndexHeader from "components/Headers/IndexHeader.jsx";
import AuthFooter from "components/Footers/AuthFooter.jsx";
// import AuthNavbar from "components/Navbars/AuthNavbar.jsx";

import { FeaturedCelebsSection, FeaturedEventsSection, Accordion } from "components";
import { PulseLoader } from 'react-spinners';

import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import GoogleLogin from 'react-google-login';
import ResponsiveEmbed from "react-responsive-embed";
import AppleSignIn from "components/AppleSignIn/AppleSignIn.jsx";
import { history, isValidEmail, isProductionBuild } from '_helpers';
import { connect } from 'react-redux';
// import { Redirect } from "react-router-dom";
import { config } from '_constants';
import { socialMediaActions, authActions, userActions, screenSizeActions, registerActions } from '_actions';
import SweetAlert from "components/react-bootstrap-sweetalert/SweetAlert.jsx";
import NotificationAlert from "components/react-notification-alert/NotificationAlert";
import defaultAvatar from "assets/img/default-avatar.png"
// import liveNyteIcon from "assets/img/img-livenyte/livenyte-square-icon.jpg"
// import {Helmet} from "react-helmet";
import AutoPlaySilentVideo from "components/AutoPlaySilentVideo/AutoPlaySilentVideo.js"
// import Linkify from 'react-linkify';
// import rocket from "assets/img/img-livenyte/rocketLiveNyte_cmrps.jpg"
// import lightbulb from "assets/img/img-livenyte/lightbulb_cmprs.jpg";
// import livenyteLogo from "assets/img/img-livenyte/livenyte-square-icon.jpg"

import musicianVideoFallback from "assets/img/img-livenyte/fallback_musician_preview_cmprs.jpg";
import crowdshot from "assets/img/img-livenyte/crowdshot.jpg";
import rainbowRoom from "assets/img/img-livenyte/rainbowRoom.jpg";
import silouhette from "assets/img/img-livenyte/silouhette.jpg";
import landingPlaceholder from "assets/img/img-livenyte/landingVideoScreen.jpg";
// import CookieManager from "components/CookieManager/CookieManager.jsx"
import eventOrganizer from "assets/img/img-livenyte/eventOrganizer.jpg";

import appStore from "assets/img/img-livenyte/appStore.png";
import playStore from "assets/img/img-livenyte/getItOnGooglePlay.png";
import { fontSize, height } from "@mui/system";
import AuthFormContainer from "./AuthFormContainer.jsx"
import AuthFormContainerXS from "./AuthFormContainerXS.jsx"

const queryString = require('query-string');

class IndexView extends React.Component {

  constructor(props) {
    super(props);
    let openSignUpModal = false
    if (props.location.state && props.location.state.hasOwnProperty('openSignUpModal')) {
      openSignUpModal = props.location.state.openSignUpModal
    }
    const screenSize = function (is_xxs, is_xs, is_sm, is_md, is_lg, is_xl, is_xxl, updateScreenSizeRequest) {
      console.log("testB", is_xxs, is_xs, is_sm, is_md, is_lg, is_xl, is_xxl, updateScreenSizeRequest, window.innerWidth, updateScreenSizeRequest)
      console.log()
      if (window.innerWidth < 430 && !updateScreenSizeRequest && !(is_xxs && is_xs && is_sm && is_md && is_lg && is_xl && is_xxl)) { //phones /Does it initialize as XXS? 
        props.dispatch(screenSizeActions.setScreenSizeXXS())
        return
      }
      else if (window.innerWidth >= 430 && window.innerWidth < 577 && !updateScreenSizeRequest && !(!is_xxs && is_xs && is_sm && is_md && is_lg && is_xl && is_xxl)) { //Does it initialize as XS? 
        props.dispatch(screenSizeActions.setScreenSizeXS())
        return
      } else if (window.innerWidth >= 577 && window.innerWidth < 769 && !updateScreenSizeRequest && !(!is_xxs && !is_xs && is_sm && is_md && is_lg && is_xl && is_xxl)) { //Does it initialize as SM? 
        props.dispatch(screenSizeActions.setScreenSizeSM())
        return
      } else if (window.innerWidth >= 769 && window.innerWidth < 993 && !updateScreenSizeRequest && !(!is_xxs && !is_xs && !is_sm && is_md && is_lg && is_xl && is_xxl)) { //Does it initialize as MD? 
        props.dispatch(screenSizeActions.setScreenSizeMD())
        return
      } else if (window.innerWidth >= 993 && window.innerWidth < 1201 && !updateScreenSizeRequest && !(!is_xxs && !is_xs && !is_sm && !is_md && is_lg && is_xl && is_xxl)) {
        props.dispatch(screenSizeActions.setScreenSizeLG())
        return
      } else if (window.innerWidth >= 1201 && window.innerWidth < 1400 && !updateScreenSizeRequest && !(!is_xxs && !is_xs && !is_sm && !is_md && !is_lg && is_xl && is_xxl)) {
        props.dispatch(screenSizeActions.setScreenSizeXL())
        return
      } else if (window.innerWidth >= 1400 && !updateScreenSizeRequest && !(!is_xxs && !is_xs && !is_sm && !is_md && !is_lg && !is_xl && is_xxl)) {
        props.dispatch(screenSizeActions.setScreenSizeXXL())
        return
      }
    }

    this.state = {
      is_xs: false,
      is_sm: false,
      is_lg: false,
      username: '',
      password: '',
      updateTerms: false,
      termsPrivacyModal: false,
      user: null,
      hTabs: "ht1",
      alert: null,
      notificationMessage: [], // [ { message: '', color: ''}]
      signUpModal: false,
      email: '',
      openSignUpModal: openSignUpModal,
      screenSize: screenSize,
      isVideoLoaded: false,
      mobileMode: "signin"

    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggleTermsPrivacyModal = this.toggleTermsPrivacyModal.bind(this);
    this.enterPressed = this.enterPressed.bind(this);
    this.notify = this.notify.bind(this);
    this.toggleSignUpModal = this.toggleSignUpModal.bind(this)
    this.setActiveContainer = this.setActiveContainer.bind(this);
    this.openSignIn = this.openSignIn.bind(this)
    this.openSignUp = this.openSignUp.bind(this)
    this.responseGoogle = this.responseGoogle.bind(this);
    this.responseFacebook = this.responseFacebook.bind(this)
    this.responseApple = this.responseApple.bind(this)
    this.handleVideo = this.handleVideo.bind(this)
    this.handleScreenSize = this.handleScreenSize.bind(this)
    this.reactivateAccountAlert = this.reactivateAccountAlert.bind(this)
    this.onLoadedData = this.onLoadedData.bind(this)
    this.startSocialRegistration = this.startSocialRegistration.bind(this);
    this.showUnauthorizedSocialMediaAlert = this.showUnauthorizedSocialMediaAlert.bind(this);
    this.startEmailRegistration = this.startEmailRegistration.bind(this);
    this.forgotPasswordAlert = this.forgotPasswordAlert.bind(this)
    this.tryAppleLogIn = this.tryAppleLogIn.bind(this)
    this.setSigninPasswordFocus = this.setSigninPasswordFocus.bind(this)
    this.setSignupEmailFocus = this.setSignupEmailFocus.bind(this)
    this.setSigninEmailFocus = this.setSigninEmailFocus.bind(this)
  }

  componentDidMount() {
    const { openSignUpModal } = this.state
    window.scrollTo(0, 0);
    this.setPropsScreenSize()
    window.addEventListener('resize', this.handleScreenSize);

    if (this.props.location.search && this.props.location.search !== "") {
      let query = queryString.parse(this.props.location.search);
      console.log("query", query)
      if (Object.prototype.hasOwnProperty.call(query, 'code')) {
        console.log("query", query)
        console.log("code", query.code)

        let rs = localStorage.getItem('fb-nonce');
        if (query.state === rs) {
          console.log("state match!!")
          // this.props.dispatch(userActions.facebookGetAccessToken(query.code, {action: 'change-username'}))
          localStorage.removeItem('fb-nonce');
        } else {
          console.log("state does not match", query.state, rs)
        }
      }
    }
    const queryParams = new URLSearchParams(this.props.location.search);
    const urlOpenSignUpModal = queryParams.get('openSignUpModal');


    if (openSignUpModal === "register" || urlOpenSignUpModal === 'register') {
      this.openSignUp()
    } else if (openSignUpModal === "login" || urlOpenSignUpModal === 'login') {
      this.openSignIn()
    }
    this.setState({
      openSignUpModal: false
    })
    this.setupVideo()
    document.documentElement.classList.remove("dark-mode");

  }

  onLoadedData = () => {
    this.setState({
      isVideoLoaded: true
    })
  };

  componentWillUnmount() {
    document.body.removeEventListener('mousedown', () => this.handleVideo('mousedown'));
    window.removeEventListener('resize', this.handleScreenSize);

  }

  handleScreenSize() {
    const { screenSize } = this.state
    const { is_xxs, is_xs, is_sm, is_md, is_lg, is_xl, is_xxl, updateScreenSizeRequest } = this.props
    console.log("testA", is_xxs, is_xs, is_sm, is_md, is_lg, is_xl, is_xxl, updateScreenSizeRequest)
    screenSize(is_xxs, is_xs, is_sm, is_md, is_lg, is_xl, is_xxl, updateScreenSizeRequest)
  }

  setPropsScreenSize() {
    if (window.innerWidth < 430) { //phones /Does it initialize as XXS? 
      this.props.dispatch(screenSizeActions.setScreenSizeXXS())
    }
    else if (window.innerWidth < 577) { //Does it initialize as XS? 
      this.props.dispatch(screenSizeActions.setScreenSizeXS())

    } else if (window.innerWidth < 769) { //Does it initialize as SM? 
      this.props.dispatch(screenSizeActions.setScreenSizeSM())

    } else if (window.innerWidth < 993) { //Does it initialize as MD? 
      this.props.dispatch(screenSizeActions.setScreenSizeMD())

    } else if (window.innerWidth < 1201) {
      this.props.dispatch(screenSizeActions.setScreenSizeLG())

    } else if (window.innerWidth < 1400) {
      this.props.dispatch(screenSizeActions.setScreenSizeXL())

    } else if (window.innerWidth >= 1400) {
      this.props.dispatch(screenSizeActions.setScreenSizeXXL())

    }

  }

  handleVideo(fired) {
    console.log("was fired", fired)
    const videoElement = document.getElementById('home_video');
    if (videoElement && videoElement.playing) {
      // video is already playing so do nothing
    }
    else if (videoElement) {
      videoElement.play();
    } else {
      console.log("Can't find video")
    }
  }

  setSigninPasswordFocus(value) {
    this.setState({
      signinPasswordFocus: value
    })
  }

  setSignupEmailFocus(value) {
    this.setState({
      signupEmailFocus: value
    })
  }

  setSigninEmailFocus(value) {
    this.setState({
      signinEmailFocus: value
    })
  }

  setupVideo() {
    // document.body.addEventListener('click touchstart', () => this.handleVideo('click touchstart'));
    // window.addEventListener('scroll', () => this.handleVideo('scroll'));
    document.body.addEventListener('mousedown', () => this.handleVideo('mousedown'));

  }

  // componentDidUpdate(prevProps, nextProps) {
  //   console.log("component did update", prevProps, nextProps, this.props)
  //   // if (prevProps.isDarkMode !== this.props.isDarkMode) {
  //   //   this.setState({
  //   //     isDarkMode: this.props.isDarkMode,
  //   //   })
  //   // }

  //   // if (prevProps.accentColor !== this.props.accentColor) {
  //   //   console.log("component did update", prevProps, nextProps, this.props)
  //   //   this.setState({
  //   //     accentColor: this.props.accentColor,
  //   //   })
  //   // }
  // }

  componentWillReceiveProps = (nextProps) => { //fixes issue where you're routing to this page from Header's Message Icon, and the page doesnt reload. this forces the page to reload.
    if (nextProps.location.key !== this.props.location.key) {
      if (nextProps.location.state && nextProps.location.state.hasOwnProperty('openSignUpModal')) {
        const openSignUpModal = nextProps.location.state.openSignUpModal
        if (openSignUpModal === "register") {
          this.openSignUp()
        } else if (openSignUpModal === "login") {
          this.openSignIn()
        }

      }
    }
  };


  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  toggleTermsPrivacyModal() {
    this.setState({
      termsPrivacyModal: !this.state.termsPrivacyModal
    });
  }

  toggleSignUpModal() {
    this.setState({
      signUpModal: !this.state.signUpModal
    });
  }

  openSignIn() {
    let url = this.getDashboardUrl()
    if (url) {
      history.push(url)
    } else {
      this.setActiveContainer("")
      this.setState({
        mobileMode: 'signin',
        signUpModal: true
      });
    }

  }

  openSignUp() {
    let url = this.getDashboardUrl()
    if (url) {
      history.push(url)
    } else {
      this.setActiveContainer("right-panel-active")
      this.setState({
        mobileMode: 'signup',
        signUpModal: true
      })
    }

  }

  setActiveContainer(newState) {
    this.setState({
      activeContainer: newState
    });
  }

  getDashboardUrl() {
    const user = JSON.parse(localStorage.getItem('user'));
    const { loggedIn } = this.props
    // const userIsAgencyAsClient = user && user.agency_as_client;
    const userIsSpecialist = loggedIn && user && user.is_specialist;
    const userIsBusiness = loggedIn && user && user.is_business;
    const userIsAgency = loggedIn && user && user.is_agency
    const userIsUser = loggedIn && user && user.is_user

    let url = userIsSpecialist ? `/dash/celeb-dashboard/` :
      userIsBusiness ? `/dash/business-dashboard/` :
        userIsAgency ? `/dash/agency-dashboard/` :
          userIsUser ? `/dash/user-dashboard/`
            : false
    return url
  }


  handleSubmit() {

    const { username, password } = this.state;
    const { dispatch } = this.props;
    if (username && password) {
      dispatch(userActions.login(username, password, (success, msg, user, isActive) => {
        if (success === false) {
          this.setState({ notificationMessage: [...this.state.notificationMessage, { message: msg, color: 2 }] })
          if (isActive === false) {
            this.reactivateAccountAlert(username)
          }
        } else if (success === true && msg === "show-terms") {
          this.toggleTermsPrivacyModal(user);
          this.setState({ user: user });
        } else {
          //Success Case--
        }
      })
      )
    } else if (!password && !username) {
      this.setState({ notificationMessage: [...this.state.notificationMessage, { message: "Please enter your email + password.", color: 2 }] })
    } else if (!password) {
      this.setState({ notificationMessage: [...this.state.notificationMessage, { message: "Please enter your password.", color: 2 }] })
    } else if (!username) {
      this.setState({ notificationMessage: [...this.state.notificationMessage, { message: "Please enter your email.", color: 2 }] })
    }

  }

  completeLogin(acceptTerms) {
    const { user } = this.state
    const { dispatch } = this.props;
    this.setState({ termsPrivacyModal: false })
    if (acceptTerms === true) {
      if (this.state.user !== null || this.state.user !== undefined) {
        dispatch(userActions.completeLogin(user));
        dispatch(userActions.termsAccepted());
      }
    } else {
      this.setState({ notificationMessage: [...this.state.notificationMessage, { message: "In order to continue using LiveNyte, you must accept LiveNyte's updated terms of service.", color: 2 }] })
    }

  }

  responseGoogle(success, response) {
    console.log("GOOGLE RESPONSE", success, response);

    if (success) {
      const creds = {
        company: 'Youtube',
        name: response.profileObj.name,
        email: response.profileObj.email,
        gender: "NA",
        id: response.tokenId,
        react: true,
        login: true,
      }
      this.props.dispatch(socialMediaActions.socialMediaConnect(creds, (success, user, isActive, email, isRegistered, isMember) => {
        //isActive and email are undefined on success 
        if (success) {
          if (user.terms_accepted === true) {
            this.props.dispatch(userActions.completeLogin(user));
          } else {
            this.toggleTermsPrivacyModal(user);
            this.setState({ user: user });
          }
        } else {
          // isActive can be false or null on fail. 
          if (isActive === false) {
            this.setState({ notificationMessage: [...this.state.notificationMessage, { message: user, color: 2 }] })
            this.reactivateAccountAlert(email)
          } else {
            if (isMember === true) {
              if (isRegistered === true) {
                const company = 'Google'
                this.showUnauthorizedSocialMediaAlert(company)
              } else {
                console.log('Social Media Connect Failed -> go to Registration ', user)
                this.startSocialRegistration(creds.email, creds.company, creds.id)
              }
            } else {
              console.log('Social Media Connect Failed -> go to Registration ', user)
              this.startSocialRegistration(creds.email, creds.company, creds.id)
            }

            // console.log('Social Media Connect Failed -> go to Registration ', user)
            // this.props.dispatch(registerActions.clearRegistrationData())
            // localStorage.setItem('auth-email', creds.email)
            // localStorage.setItem('auth-social', creds.company)
            // localStorage.setItem('auth-socialToken', creds.id)
            // history.replace('/auth/register-page')
            // console.log("In registration case")   

          }
        }
      }))
    }
  }

  responseFacebook(response) {
    console.log("FACEBOOK RESPONSE", response);
    if (response && response.hasOwnProperty('userID') && response.hasOwnProperty('accessToken')) {
      const creds = {
        company: 'Facebook',
        name: response.name,
        email: response.email,
        gender: 'NA',
        id: response.userID,
        react: true,
        login: true,
      };
      this.props.dispatch(socialMediaActions.socialMediaConnect(creds, (success, user, isActive, email, isRegistered, isMember) => {
        //isActive and email are undefined on success 
        if (success) {
          if (user.terms_accepted === true) {
            this.props.dispatch(userActions.completeLogin(user));
          } else {
            this.toggleTermsPrivacyModal(user);
            this.setState({ user: user });
          }
        } else {
          // isActive can be false or null on fail. 
          if (isActive === false) {
            this.setState({ notificationMessage: [...this.state.notificationMessage, { message: user, color: 2 }] })
            this.reactivateAccountAlert(email)
          } else {

            if (isMember === true) {
              if (isRegistered === true) {
                this.showUnauthorizedSocialMediaAlert(creds.company)
              } else {
                console.log('Social Media Connect Failed -> go to Registration ', user)
                this.startSocialRegistration(creds.email, creds.company, creds.id)
              }
            } else {
              console.log('Social Media Connect Failed -> go to Registration ', user)
              this.startSocialRegistration(creds.email, creds.company, creds.id)
            }
            // console.log('Social Media Connect Failed -> go to Registration ', user)
            // this.props.dispatch(registerActions.clearRegistrationData())
            // localStorage.setItem('auth-email', creds.email)
            // localStorage.setItem('auth-social', creds.company)
            // localStorage.setItem('auth-socialToken', creds.id)
            // history.replace('/auth/register-page')
            // console.log("In registration case")  
          }
        }
      }))
    }
  }

  showUnauthorizedSocialMediaAlert(company) {
    console.log("In showUnauthorizedSocialMediaAlert")
    this.setState({
      alert: (
        <SweetAlert
          danger
          forceLightMode
          title={`${company} has not been authorized to login to this LiveNyte account.`}
          onConfirm={() => this.hideAlert()}
          confirmBtnText="Dismiss"
          confirmBtnBsStyle="primary"
        >
          <div className="text-left">

            <p className="">{(`A LiveNyte account exists with the same email address as this ${company} account. ` +
              `However, that LiveNyte account never authorized ${company} as a login method for this account.  ` +
              `For account security reasons, we can't log you in via this method.`)} </p>
            <p >{(`Please login to your account with another method.`)}</p>
            <p >{(`Once you're logged into your account, you can allow future logins with ${company} by going to Account -> Settings -> Social Login. ` +
              `From there, connect your ${company} account to allow future logins via ${company}.`)}</p>
          </div>
        </SweetAlert>
      )
    });

    // const title =  `${company} has not been authorized to login to this LiveNyte account.`
    // const message =  (`A LiveNyte account exists with the same email address as this ${company} account. ` +
    //         `However, that LiveNyte account never authorized ${company} as a login method for this account.  ` +
    //         `For account security reasons, we can't log you in via this method.\n\n` +
    //         `Please login to your account with another method.\n\n` +
    //         `Once you're logged into your account, you can allow future logins with ${company} by going to Account -> Settings -> Social Login. ` +
    //         `From there, connect your ${company} account to allow future logins via ${company}.`)
  }

  startSocialRegistration(email, company, id) {
    this.props.dispatch(registerActions.clearRegistrationData())
    localStorage.setItem('auth-email', email)
    localStorage.setItem('auth-social', company)
    localStorage.setItem('auth-socialToken', id)
    history.replace('/auth/register-page')
    console.log("In registration case")
  }

  responseApple(successApple, response, redirectUri) {
    if (successApple) {
      console.log("responseApple Success", successApple, response)
      const idToken = response.authorization.id_token
      const appleAccessArgs = {
        id_token: idToken,
      }
      const creds = {
        company: 'Apple',
        gender: 'NA',
        id: idToken,
        react: true,
        login: true,
      };
      if (response.hasOwnProperty('user') && response.user.hasOwnProperty("name")) {
        const name = response.user.name.firstName + " " + response.user.name.lastName
        creds['name'] = name
        appleAccessArgs['name'] = name

      }
      if (response.hasOwnProperty('user') && response.user.hasOwnProperty("email")) {
        creds['email'] = response.user.email
        appleAccessArgs['email'] = response.user.email
      }
      console.log("apple access args", appleAccessArgs)
      this.props.dispatch(userActions.appleGetAccessToken(appleAccessArgs, (success, data) => {
        if (success && data.hasOwnProperty('unregistered') && data.unregistered === false) {
          console.log("Apple Access Token Success", data)
          this.props.dispatch(socialMediaActions.socialMediaConnect(creds, (successApple, user, isActive, email) => {
            //isActive and email are undefined on success 
            if (successApple) {
              if (user.terms_accepted === true) {
                this.props.dispatch(userActions.completeLogin(user));
              } else {
                // isActive can be false or null on fail. 
                if (isActive === false) {
                  this.setState({ notificationMessage: [...this.state.notificationMessage, { message: user, color: 2 }] })
                  this.reactivateAccountAlert(email)
                } else if (isActive === null) {
                  this.toggleTermsPrivacyModal(user);
                  this.setState({ user: user });
                }
              }
            } else {
              console.log("Fail SocialMedia Connect", success)
            }
          }))
        } else if (success && data.hasOwnProperty('unregistered') && data.unregistered === true && data.hasOwnProperty('email')) {
          console.log('Social Media Connect Failed -> go to Registration ', user)
          this.startSocialRegistration(data.email, creds.company, creds.id)
          console.log("GET APPLE ACCESS TOKEN success. Unregistered user. Go to registration ", data)
          this.props.dispatch(registerActions.clearRegistrationData())
          localStorage.setItem('auth-email', data.email)
          localStorage.setItem('auth-social', creds.company)
          localStorage.setItem('auth-socialToken', creds.id)
          history.replace('/auth/register-page')
          console.log("In registration case")
        } else {
          console.log("Fail Apple Get Access Token", data)
        }
      }))
    } else {
      console.log("responseApple Failure", successApple, response)
    }
  }

  forgotPasswordAlert() {
    this.setState({
      alert: (
        <SweetAlert
          input
          forceLightMode
          inputType="email"
          title="Forgot your password?"
          onConfirm={email => this.sendResetPasswordEmail(email)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="primary"
          confirmBtnText="Send"
          inputPlaceHolder
          placeholder="Enter your email address."
          showCancel
        >
          <p className="text-center text-darkerGray">
            <span>
              <p> We'll send an email to your email address to help you reset your password.<span className="title"></span>
              </p>
              {/* <br/>Please click the link in the email to continue the account recovery process. */}
            </span>
          </p>
        </SweetAlert>
      )
    });
  }

  sendResetPasswordEmail(email) {
    this.props.dispatch(authActions.authResetPassword(email, (success, data) => {
      if (success) {
        this.setState({
          alert: (
            <SweetAlert
              success
              forceLightMode
              title="Check your email"
              onConfirm={() => this.hideAlert()}
              confirmBtnBsStyle="primary"
              confirmBtnText="Close"
            >
              <p className="text-center text-darkerGray">
                <span>
                  <span className="h4"> We just sent an email to <span className="title">{email}</span>.
                  </span>
                  <br />Please click the link in the email to continue the account recovery process.
                </span>
              </p>
            </SweetAlert>
          )
        });
      } else {

      }
    }))

  }

  hideAlert() {
    this.setState({
      alert: null
    });
  }

  enterPressed(event) {
    var code = event.keyCode || event.which;
    const { activeContainer } = this.state
    if (code === 13) {     //13 is the enter keycode
      if (activeContainer === "right-panel-active") {
        this.startEmailRegistration()
      } else {
        this.handleSubmit();

      }
    }

  }

  // notify(place, color, message) {
  notify() {
    const { notificationMessage } = this.state
    // console.log("notify", notificationMessage)
    if (notificationMessage.length === 0) {
      return;
    }
    let type;
    switch (notificationMessage[0].color) {
      case 1:
        type = "success";
        break;
      case 2:
        type = "danger";
        break;

      default:
        break;
    }
    let options = {};
    options = {
      place: "tr",
      message: (
        <div>
          <div>
            {notificationMessage[0].message}
          </div>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 7
    };
    console.log("refs", this.refs)
    if (this.refs.hasOwnProperty('notificationAlert')) {
      let nm = [...notificationMessage]
      nm.splice(0, 1)
      this.setState({ notificationMessage: nm })
      this.refs.notificationAlert.notificationAlert(options);
    }
  }

  async tryAppleLogIn(e) {
    if (e) {
      e.preventDefault();
    }

    try {
      const data = await window.AppleID.auth.signIn()
      // console.log("initalize AppleSignIn request", data)
      this.responseApple(true, data)
    } catch (error) {
      // console.log("Data from AppleSignIn", error)
      this.responseApple(false, error)
    }

    // console.log("Data from AppleSignIn", data)
  }


  startEmailRegistration() {
    const { email } = this.state
    console.log("email", email)
    if (isValidEmail(email)) {
      this.props.dispatch(authActions.authRegistrationEmail(email, (success, data) => {
        if (success) {
          this.sentEmailRegistrationAlert(email)
        } else {
        }

      }))
    } else {
      this.invalidEmailAlert(email)
    }

  }

  sentEmailRegistrationAlert(email) {
    this.setState({
      alert: (
        <SweetAlert
          success
          forceLightMode
          title="Confirm your Email Address"
          onConfirm={() => this.hideAlert()}
          confirmBtnBsStyle="primary"
          confirmBtnText="Close"
        >
          <p className="text-center text-darkerGray">
            <span>
              <span className="h4"> We just sent an email to <span className="title">{email}</span>.
              </span>
              <br />Please click the link in the email to continue the registration process.
            </span>
          </p>
        </SweetAlert>
      ),
      email: ''
    });
  }

  invalidEmailAlert(email) {
    this.setState({
      alert: (
        <SweetAlert
          danger
          forceLightMode
          title="Invalid Email Address"
          onConfirm={() => this.hideAlert()}
          confirmBtnBsStyle="primary"
          confirmBtnText="Close"
        >
          <p className="text-center text-darkerGray">
            <span>
              <h4>
                <span className="title">{email}</span> is an invalid email address.
              </h4>
              <br />Please use a valid email address.
            </span>
          </p>
        </SweetAlert>
      )
    });
  }

  reactivateAccountAlert(email) {
    this.setState({
      alert: (
        <SweetAlert
          forceLightMode
          title="Reactivate Account?"
          onConfirm={() => this.reactivateAccountSuccessAlert(email)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="success"
          confirmBtnText="Reactivate"
          showCancel
        >
          <p className="text-center text-darkerGray">
            <span>
              <span className="h4">Your account is currently deactivated.
              </span>
              <br /> Would you like to reactivate your account?
            </span>
          </p>
        </SweetAlert>
      )
    });
  }

  reactivateAccountSuccessAlert(email) {
    this.props.dispatch(authActions.reactivateAccount(email, (success, data) => {
      if (success) {
        this.setState({
          alert: (
            <SweetAlert
              success
              forceLightMode
              title="Check your email"
              onConfirm={() => this.hideAlert()}
              confirmBtnBsStyle="primary"
              confirmBtnText="Close"
            >
              <p className="text-center text-darkerGray">
                <span>
                  <span className="h4">We just sent a reactivation email to the email address associated with this LiveNyte account.
                  </span>
                  <br /> Please click the button in the reactivation email to reactivate your LiveNyte account.
                </span>
              </p>
            </SweetAlert>
          )
        });
      }
    }))
  }

  getLiveNyteCard() {
    const { loggedIn, info, is_md, fanMode } = this.props
    const user = JSON.parse(localStorage.getItem('user'));
    // const userIsAgencyAsClient = user && user.agency_as_client;
    const userIsSpecialist = loggedIn && user && user.is_specialist;
    const userIsBusiness = loggedIn && user && user.is_business;
    const userIsAgency = loggedIn && user && user.is_agency

    return (
      <div className={"pb-4 "}>
        <h1 className={"display-1 mb-0 livenyte-title " + (is_md ? "text-primary" : "text-primary")}>
          LiveNyte
        </h1>
        <h2 className={"display-4 font-weight-light " + (is_md ? "text-white" : "")}>
          Host events. Book talent. Sell tickets.
        </h2>
        <div className="pt-1 mt-1">
          <span className={" " + (is_md ? "text-lighter" : "")} style={{ fontSize: "1.13rem" }}>
            Get started for free.
          </span >
        </div>

        {loggedIn &&
          <div className="mt-4 ">
            <Link to={{
              pathname:
                userIsSpecialist && !fanMode ? `/dash/celeb-dashboard/` :
                  userIsBusiness && !fanMode ? `/dash/business-dashboard/` :
                    userIsAgency && !fanMode ? `/dash/agency-dashboard/` : `/dash/user-dashboard/`
            }} >
              <Media className="align-items-center cursor ">
                <span className="avatar avatar-sm rounded-circle">
                  <img
                    alt="..."
                    className="avatar-sm"
                    src={info && info.image ? info.image : defaultAvatar}
                    onError={(e) => { e.target.onerror = null; e.target.src = defaultAvatar }}
                  />
                </span>
                <Media className="ml-2 ">
                  <span className={"mb-0 text-sm font-weight-bold " + (is_md ? "text-white" : "text-default ")}>
                    {info && info.name ? info.name : "Log In"}
                  </span>
                </Media>
              </Media>
              <Button
                className="mt-4 bg-gradient-livenyte"
                color="primary"
              >
                Let's go
              </Button>
            </Link>
          </div>
        }
        {!loggedIn &&
          <div className="mt-4 pt-2">
            <Button
              color="primary"
              onClick={this.openSignUp}
              className="bg-gradient-livenyte"
            >
              Get started
            </Button>
          </div>
        }
        {!loggedIn &&
          <div className="pt-3">
            <small onClick={this.openSignIn} className={"text-small cursor-pointer pt-3  " + (is_md ? "text-white" : "")}>
              Already have an account? <span className="text-primary title">Sign in here.  </span>
            </small>
          </div>
        }
        <Row className="mt-4 pt-1">
          <Col xs={12} className="mr-auto">
            <a href="https://itunes.apple.com/us/app/livenyte/id1378430467?mt=8"
              className={"btn-app mr-2"} style={{ height: "51px", }}>
              <img src={appStore} alt="App Store Button" />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.kunal.livenyte.livenyte"
              className={"btn-app"}>
              <img src={playStore} alt="Play Store Button" />
            </a>
          </Col>
        </Row>
      </div>

    )
  }



  render() {
    const { username, password, activeContainer, signupNameFocus, signupEmailFocus, signupPasswordFocus, signinEmailFocus, signinPasswordFocus, isVideoLoaded } = this.state;
    const { loggedIn, info, is_md, updateScreenSizeRequest } = this.props
    const user = JSON.parse(localStorage.getItem('user'));
    // const userIsAgencyAsClient = user && user.agency_as_client;
    const userIsSpecialist = loggedIn && user && user.is_specialist;
    const userIsBusiness = loggedIn && user && user.is_business;
    const userIsAgency = loggedIn && user && user.is_agency
    // const userIsUser = loggedIn && user && user.is_user
    console.log("test props", this.props)
    if (updateScreenSizeRequest === null) {
      return (
        <>
          <header className="header-4 "
            style={{
              height: "100vh",
              // backgroundSize: "cover", backgroundImage: "url(" + (rainbowRoom) + ")"
              background: "linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ), url(" + (rainbowRoom) + ")",
              backgroundPosition: "center top",
              backgroundSize: "cover"


            }}
          >
            <div className="header-wrapper">
              <div className="page-header header-video">
                <div className="overlay"></div>
                <Container style={{ paddingTop: "0vh" }}>
                  <Row>
                    <Col className="mx-auto px-0" lg="12">
                      <Card className=" bg-transparent-carbon card-box-shadow mb-0">
                        <CardBody>
                          <div className={"pb-4 "}>
                            <h1 className={"display-1 mb-0 livenyte-title text-primary"}>
                              LiveNyte
                            </h1>
                            <h2 className={"display-4 font-weight-light text-white inline-block"}>
                              Logging Out
                            </h2>
                            <div className='sweet-loading inline-block'
                              style={{ transform: "translate(6px,  4px)" }}>
                              <PulseLoader
                                sizeUnit={"px"}
                                size={7}
                                color={'#fff'}

                              />
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Container>
              </div>
            </div>
          </header>
        </>
      )
    }

    return (
      <>
        <div className="bg-secondary">
          <IndexNavbar isDarkGlassMode={false} />
          <div className="rna-wrapper">
            <NotificationAlert ref="notificationAlert" />
          </div>
          <div className="main-content">
            {this.notify()}
            {this.state.alert}
            <div className={this.props.is_md ? "" : ""}>
              <header className={"header-4 "}>
                {this.props.is_md &&
                  <div className="header-wrapper">
                    <div className="page-header header-video">
                      <div className="overlay"></div>
                      <div className="">
                        {!isVideoLoaded &&
                          <img
                            src={landingPlaceholder}
                            className=" progressiveVideo-tiny objectFitCover z98"
                            alt="thumb"
                            style={{ position: "absolute", right: "0", opacity: isVideoLoaded ? 0 : 1 }}
                          />
                        }
                        <AutoPlaySilentVideo
                          video={config.commonUrl + "/Common/Landing_Video_Vertical_2.mp4"}
                          // video={landingVideo}
                          className="test-video"
                          isVideoLoaded={isVideoLoaded}
                          onLoadedData={this.onLoadedData}
                          id="home_video"
                        />
                      </div>
                      <Container className="" style={{ paddingTop: "0" }}>
                        <Row>
                          <Col className="mx-auto px-0" lg="12">
                            <Card className=" bg-transparent-carbon card-box-shadow mb-0">
                              <CardBody>
                                {this.getLiveNyteCard()}
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </Container>
                    </div>
                  </div>
                }
                {!this.props.is_md &&
                  <div>
                    <Row className="align-items-center text-left bg-white mx-0">
                      <Col lg="5" xs="11" className={this.props.is_md ? "mx-auto mt-3 pt-6" : "ml-auto mt-3"}>
                        {this.getLiveNyteCard()}
                      </Col>
                      {
                        <Col className="text-right ml-auto overlay px-0" lg="6" xs="12">
                          <div className="progressiveVideoContainer" >
                            {isVideoLoaded &&
                              <img
                                src={landingPlaceholder}
                                className="headerVideo progressiveVideo-tiny z98 "
                                alt="thumb"
                                onContextMenu={e => e.preventDefault()}
                                style={{ position: "absolute", right: "0", opacity: isVideoLoaded ? 0 : 1 }}
                              />
                            }
                            <AutoPlaySilentVideo
                              video={config.commonUrl + "/Common/Landing_Video_Vertical_2.mp4"}
                              // video={landingVideo}
                              className="headerVideo"
                              isVideoLoaded={isVideoLoaded}
                              onLoadedData={this.onLoadedData}
                              id="home_video"
                            />
                          </div>
                        </Col>
                      }
                    </Row>
                  </div>
                }
              </header>
            </div>
            <section className="section section-lg pt-lg-0 mt--7">
              <Container>
                <Row className="justify-content-center">
                  <Col lg="12">
                    <Row>
                      <Col lg="4">
                        <Card className="card-lift--hover shadow border-0">
                          <CardBody className="py-5 text-center">
                            <h4 className="display-3 text-default livenyte-title">
                              Talent
                            </h4>
                            <p className="display-5 mt-3" style={{ fontSize: "1.13rem" }}>
                              Turn your followers into a fanbase—with live gigs and digital exclusives.
                            </p>
                            <div>
                              <Link to={{ pathname: '/auth/creatorLanding' }}>
                                <Button style={{ fontSize: "1rem" }} color="primary" block className="mt-4" size={"lg"} >Learn more</Button>
                              </Link>
                              {/* <Badge color="primary" pill>
                            react
                          </Badge>
                          <Badge color="primary" pill>
                            reactstrap
                          </Badge>
                          <Badge color="primary" pill>
                            dashboard
                          </Badge>
                          <Badge color="primary" pill>
                            template
                          </Badge> */}
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                      <Col lg="4">
                        <Card className="card-lift--hover shadow border-0">
                          <CardBody className="py-5 text-center">
                            <h4 className="display-3 text-default livenyte-title">
                              Businesses
                            </h4>
                            <p className="display-5 mt-3" style={{ fontSize: "1.13rem" }}>
                              Find great talent, sell tickets, and bring the right fans to your event.
                            </p>
                            <div>
                              <Link to={{ pathname: '/auth/businessLanding' }}>
                                <Button style={{ fontSize: "1rem" }} color="tertiary" block className="mt-4" size={"lg"} >Learn more</Button>
                              </Link>
                              {/* <Badge color="primary" pill>
                            npm
                          </Badge>
                          <Badge color="primary" pill>
                            build tools
                          </Badge> */}
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                      <Col lg="4">
                        <Card className="card-lift--hover shadow border-0">
                          <CardBody className="py-5 text-center">
                            <h4 className="display-3 text-default livenyte-title">
                              Fans
                            </h4>
                            <p className="display-5  mt-3" style={{ fontSize: "1.13rem" }}>
                              Find local events you'll love—and get closer to the artists you follow.
                            </p>
                            <div>
                              <Link to={{ pathname: '/auth/fanLanding' }}>
                                <Button style={{ fontSize: "1rem" }} color="info" block className="mt-4" size={"lg"} >Learn more</Button>
                              </Link>
                              {/* <Badge color="primary" pill>
                            sass
                          </Badge>
                          <Badge color="primary" pill>
                            design
                          </Badge>
                          <Badge color="primary" pill>
                            customize
                          </Badge> */}
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Container>
            </section>
            <section className="pb-6 ">
              <Container fluid>
                <div className="">
                  <Row className="justify-content-center text-center my-4">
                    <Col xs={12}>
                      <div className="display-3 surtitle text-default text-uppercase mb-0 livenyte-title special-underline-livenyte mb-2">
                        <span style={{ display: "inline-block" }}>Who is <span style={{ display: "inline-block" }}>LiveNyte</span> for?</span>
                      </div>
                    </Col>
                  </Row>
                  <Row className="justify-content-center text-center">
                    <Col md="12" lg="12" className=" mx-auto text-center">
                      {/* <span className="display-3 surtitle text-default  mb-0 livenyte-title mb-2">WHAT YOU GET</span> */}
                    </Col>
                    <Col md={4} xs={12} className="my-4">
                      <Card className="card-lift--hover shadow border-0 text-center align-items-center">
                        <CardBody>
                          <div className="icon icon-lg icon-shape mt-4">
                            <i className="fas fa-star text-primary" style={{ fontSize: "5rem" }} />
                          </div>
                          <h4 className="display-3 mt-4 text-default livenyte-title">
                            Emerging Talent
                          </h4>
                          <div className='mt-3 mx-auto pb-2'>
                            <p className="display-5 mt-3" style={{ fontSize: "1.13rem" }}>
                              Get booked, sell content, and grow your audience—all in one place.
                            </p>
                          </div>
                          <Link to={{ pathname: '/auth/creatorLanding' }}>
                            <Button style={{ fontSize: "1rem" }} color="primary" block className="mt-4" size={"lg"} >Learn more</Button>
                          </Link>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col md={4} xs={12} className="my-4">
                      <Card className="card-lift--hover shadow border-0 text-center align-items-center">
                        <CardBody>
                          <div className="icon icon-lg icon-shape mt-4">
                            <i className="fas fa-building text-tertiary" style={{ fontSize: "5rem" }} />
                          </div>
                          <h4 className="display-3 mt-4 text-default livenyte-title">
                            Neighborhood Venues
                          </h4>
                          <div className='mt-3 mx-auto pb-2'>
                            <p className="display-5 mt-3" style={{ fontSize: "1.13rem" }}>
                              Sell tickets, run events, and build momentum for local talent.
                            </p>
                          </div>
                          <Link to={{ pathname: '/auth/creatorLanding' }}>
                            <Button style={{ fontSize: "1rem" }} color="tertiary" block className="mt-4" size={"lg"} >Learn more</Button>
                          </Link>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col md={4} xs={12} className="my-4">
                      <Card className="card-lift--hover shadow border-0 text-center align-items-center">
                        <CardBody>
                          <div className="icon icon-lg icon-shape mt-4">
                            <i className="fas fa-ticket text-purple" style={{ fontSize: "5rem" }} />
                          </div>
                          <h4 className="display-3 mt-4 text-default livenyte-title">
                            Event Promoters
                          </h4>
                          <div className='mt-3 mx-auto pb-2'>
                            <p className="display-5 mt-3" style={{ fontSize: "1.13rem" }}>
                              Sell tickets, run events, and build momentum for local talent.
                            </p>
                          </div>
                          <Link to={{ pathname: '/auth/creatorLanding' }}>
                            <Button style={{ fontSize: "1rem" }} color="purple" block className="mt-4" size={"lg"} >Learn more</Button>
                          </Link>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                  {/* {!loggedIn && 
          <div>
          <Row className=" mt-2 text-center ">
            <Col md={6} xs={8} className="text-center mx-auto ">
              <Button
                color="primary"
                onClick={this.openSignUp}
                size="lg"
                block
                style={{fontSize:"1rem"}} 
                className="bg-gradient-livenyte"
                >
                Sign Up
              </Button>
            </Col>
          </Row>
        </div>
            } */}
                </div>

              </Container>

            </section>
            <section className="pb-6 ">
              <Container fluid>
                <div className="">
                  <Row className="justify-content-center text-center my-4">
                    <Col xs={12}>
                      <span className="display-3 surtitle text-default  mb-0 livenyte-title special-underline-livenyte mb-2">HOW IT WORKS</span>
                    </Col>
                  </Row>
                  <Row className="justify-content-center text-center">
                    <Col md="12" lg="12" className=" mx-auto text-center">
                      {/* <span className="display-3 surtitle text-default  mb-0 livenyte-title mb-2">WHAT YOU GET</span> */}
                    </Col>
                    <Col md={4} xs={12} className="my-4">
                      <div className="icon icon-lg icon-shape mt-4">
                        <i className="fas fa-star text-primary" style={{ fontSize: "5rem" }} />
                      </div>
                      <h4 className="display-3 mt-4 pb-2 text-default livenyte-title">
                        Talent
                      </h4>
                      <div className='mt-3 mx-auto' style={{ maxWidth: '500px' }}>
                        <ul className="text-left list-unstyled mx-auto px-4">
                          <li>
                            <div className="d-flex align-items-left ml-4">
                              <div>
                                <div className="icon icon-md icon-shape bg-gradient-livenyte shadow rounded-circle text-white">
                                  <i className="fas fa-star" />
                                </div>
                              </div>
                              <div>
                                <h2 className="mt--1 pl-4 text-default  font-weight-normal">Set up your profile and showcase what you do</h2>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="d-flex align-items-left mt-3 ml-4">
                              <div>
                                <div className="icon icon-md icon-shape  bg-gradient-livenyte shadow rounded-circle text-white">
                                  <i className="fas fa-bolt" />
                                </div>
                              </div>
                              <div>
                                <h2 className="mt--1 pl-4 text-default  font-weight-normal">
                                  Get booking offers and build your audience
                                </h2>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="d-flex align-items-left mt-3 ml-4">
                              <div>
                                <div className="icon icon-md icon-shape  bg-gradient-livenyte shadow rounded-circle text-white">
                                  <i className="fas fa-video" />
                                </div>
                              </div>
                              <div>
                                <h2 className="mt--1 pl-4 text-default  font-weight-normal">Earn through live shows and digital content</h2>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </Col>
                    <Col md={4} xs={12} className="my-4">
                      <div className="icon icon-lg icon-shape mt-4">
                        <i className="fas fa-ticket text-tertiary" style={{ fontSize: "5rem" }} />
                      </div>
                      <h4 className="display-3 mt-4 pb-2 text-default livenyte-title">
                        Businesses
                      </h4>
                      <div className='mt-3 mx-auto' style={{ maxWidth: '500px' }}>
                        <ul className="text-left list-unstyled mx-auto px-4">
                          <li>
                            <div className="d-flex align-items-left ml-4">
                              <div>
                                <div className="icon icon-md icon-shape bg-gradient-purple shadow rounded-circle text-white">
                                  <i className="fas fa-ticket" />
                                </div>
                              </div>
                              <div>
                                <h2 className="mt--1 pl-4 text-default  font-weight-normal">Find and book the right talent for your events</h2>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="d-flex align-items-left mt-3 ml-4">
                              <div>
                                <div className="icon icon-md icon-shape  bg-gradient-purple shadow rounded-circle text-white">
                                  <i className="fas fa-bolt" />
                                </div>
                              </div>
                              <div>
                                <h2 className="mt--1 pl-4 text-default  font-weight-normal">
                                  Sell tickets and manage everything in one place
                                </h2>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="d-flex align-items-left mt-3 ml-4">
                              <div>
                                <div className="icon icon-md icon-shape bg-gradient-purple shadow rounded-circle text-white">
                                  <i className="fas fa-video" />
                                </div>
                              </div>
                              <div>
                                <h2 className="mt--1 pl-4 text-default  font-weight-normal">Promote directly to fans of the talent you book</h2>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </Col>
                    <Col md={4} xs={12} className="my-4">
                      <div className="icon icon-lg icon-shape mt-4 mt-4">
                        <i className="icon-fanGlyph text-info" style={{ fontSize: "5rem" }} />
                      </div>
                      <h4 className="display-3 mt-4 pb-2 text-default livenyte-title">
                        Fans
                      </h4>
                      <div className='mt-3 mx-auto' style={{ maxWidth: '500px' }}>
                        <ul className="text-left list-unstyled mx-auto px-4">
                          <li>
                            <div className="d-flex align-items-left ml-4">
                              <div>
                                <div className="icon icon-md icon-shape bg-gradient-cyan shadow rounded-circle text-white">
                                  <i className="fas fa-star" />
                                </div>
                              </div>
                              <div>
                                <h2 className="mt--1 pl-4 text-default  font-weight-normal">	Discover local events and live shows you'll love</h2>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="d-flex align-items-left mt-3 ml-4">
                              <div>
                                <div className="icon icon-md icon-shape  bg-gradient-cyan shadow rounded-circle text-white">
                                  <i className="fas fa-bolt" />
                                </div>
                              </div>
                              <div>
                                <h2 className="mt--1 pl-4 text-default  font-weight-normal">
                                  Support your favorite performers & local scene
                                </h2>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="d-flex align-items-left mt-3 ml-4">
                              <div>
                                <div className="icon icon-md icon-shape  bg-gradient-cyan shadow rounded-circle text-white">
                                  <i className="fas fa-video" />
                                </div>
                              </div>
                              <div>
                                <h2 className="mt--1 pl-4 text-default  font-weight-normal">	Get access to exclusive content and subscriptions</h2>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </Col>
                  </Row>
                  {!loggedIn &&
                    <div>
                      <Row className=" mt-2 text-center ">
                        <Col md={6} xs={11} className="text-center mx-auto ">
                          <Button
                            color="primary"
                            onClick={this.openSignUp}
                            size="lg"
                            block
                            style={{ fontSize: "1rem" }}
                            className="bg-gradient-livenyte"
                          >
                            Sign Up
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  }
                </div>

              </Container>

            </section>
            <FeaturedCelebsSection />
            <FeaturedEventsSection />

            <section className="py-6  px-0">
              <Container fluid>
                <Row className="justify-content-center text-center my-4">
                  <Col xs={12}>
                    <span className="display-3 surtitle text-default  mb-0 livenyte-title special-underline-livenyte mb-2">Curious about costs?</span>
                  </Col>
                </Row>
                <Row className="justify-content-center text-center">
                  <Col xs="11" md="8" className="text-center mx-auto">
                    <p className="display-5 mt-3" style={{ fontSize: "1.13rem" }}>
                      LiveNyte has no upfront or subscription fees. We only earn when you do.
                      <br />
                      View our pricing breakdown by role.
                    </p>
                  </Col>
                </Row>
                <Row className="justify-content-center text-center">
                  <Col lg="4" xs={11} className="mx-auto">
                    <Link to={{ pathname: '/auth/pricing' }}>
                      <Button style={{ fontSize: "1rem" }} color="success" block outline className="mt-4" size={"lg"} >View Pricing</Button>
                    </Link>
                  </Col>
                </Row>
              </Container>
            </section>

            <section className="py-6 px-0">
              <Container fluid>
                <Row className="justify-content-center text-center my-4">
                  <Col xs={12}>
                    <span className="display-3 surtitle text-default  mb-0 livenyte-title special-underline-livenyte mb-2">FAQ</span>
                  </Col>
                </Row>
                <Row className="my-4">
                  <Col lg={9} md={12} xs={12} className="mx-auto">
                    <Accordion plain>
                      <Accordion.Item title="Is LiveNyte free to use?">
                        <p>
                          Yes—there are no upfront or subscription fees. We only take a small cut when bookings or sales happen.
                        </p>
                      </Accordion.Item>

                      <Accordion.Item title="Do I need to be a professional to sign up?">
                        <p>
                          Nope. Whether you're just starting out or already performing, LiveNyte is open to all talent & creators.
                        </p>
                      </Accordion.Item>

                      <Accordion.Item title="Who can use LiveNyte?">
                        <p>
                          Talent, fans, and businesses looking to book or host live experiences.
                        </p>
                      </Accordion.Item>

                      <Accordion.Item title="How do payments work?">
                        <p>
                          It depends on what you're selling:
                        </p>
                        <p>
                          • <strong>Event Bookings</strong><br />
                          You'll get paid a few days after the event, as long as no dispute is filed. Businesses have a short window to raise any issues before payment is released.
                        </p>
                        <p>
                          • <strong>Subscriptions</strong><br />
                          You'll be paid monthly or yearly, depending on the type of subscription your fan chooses. Payments are processed at the beginning of each billing cycle.
                        </p>
                        <p>
                          • <strong>Ticket Sales</strong><br />
                          You'll receive your share after the event concludes. This helps us prevent fraud and manage refunds if needed.
                        </p>
                        <p>
                          Note: All payouts are securely processed through Stripe. You can track earnings and payout dates in your dashboard.
                        </p>
                      </Accordion.Item>
                    </Accordion>
                  </Col>
                </Row>
              </Container>
            </section>

            <section className="pb-7 pt-4 mt-4 bg-darkMode px-0">
              <Container fluid>
                <div className="pt-4 pb-4 text-center mx-auto justify-content-center">
                  <Badge className="badge-gradient-lg surtitle text-white bg-gradient-livenyte my-2" color="primary" pill>
                    <h5 className="surtitle text-white">LAUNCHING NOW</h5>
                  </Badge>
                </div>
                <Row className="justify-content-center text-center my-4">
                  <Col xs={12}>
                    <span className="display-3 text-center surtitle text-white mb-0 livenyte-title special-underline-livenyte mb-2 glitch-text glitch-text-animated">Live in California —<br />Let's Get Things Started</span>
                  </Col>
                </Row>
                <Row className="justify-content-center text-center">
                  <Col xs="11" md="8" className="text-center mx-auto">
                    <p class="display-5 mt-3 text-white" style={{ fontSize: "1.13rem" }}>LiveNyte is live — and we're now building out our event communities city by city. If you're in California, this is your chance to join early, get discovered, and help shape how live events grow in your area.</p>
                    <h2 className="mt-4 text-center text-white mt-1">
                      Even if your city isn't featured yet, the full platform is open. Build your profile, get booked, sell content — and be ready when things heat up in your area.
                    </h2>
                  </Col>
                </Row>
                <Row className="justify-content-center text-center mt-1">
                  <Col sm="4" xs={11} className={(this.props.is_xs ? "mx-auto" : "ml-auto")}>
                    <Link to={{ pathname: '/sf' }}>
                      <Button style={{ fontSize: "1.1rem" }} color="white" outline block className="mt-4 " size={"lg"} >SF Bay Area</Button>
                    </Link>
                    <Link to={{ pathname: '/sactown' }}>
                      <Button style={{ fontSize: "1.1rem" }} color="white" outline block className="mt-4 " size={"lg"} >Sactown</Button>
                    </Link>
                  </Col>
                  <Col sm="4" xs={11} className={(this.props.is_xs ? "mx-auto" : "mr-auto")}>
                    <Link to={{ pathname: '/la' }}>
                      <Button style={{ fontSize: "1.1rem" }} color="white" outline block className="mt-4 " size={"lg"} >Los Angeles</Button>
                    </Link>
                    <Link to={{ pathname: '/sd' }}>
                      <Button style={{ fontSize: "1.1rem" }} color="white" outline block className="mt-4 " size={"lg"} >San Diego</Button>
                    </Link>
                  </Col>
                  <Col xs={11} sm={8} className="mx-auto dark-mode">
                    <Card className="no-box-shadow mt-5">
                      <Row className="justify-content-center text-center my-4">
                        <Col xs={12}>
                          <span className="display-3 text-center surtitle text-white mb-0 livenyte-title special-underline-livenyte mb-2 glitch-text glitch-text-animated">FAQ</span>
                        </Col>
                      </Row>
                      <CardBody className="text-left  pt-0">
                        <Accordion plain darkMode>
                          <Accordion.Item title="📍 I'm not in these areas. Can I still sign up?">
                            <p>
                              Absolutely. You're welcome to sign up, create your profile, and use the platform from anywhere.
                              We're currently focusing on launching events in select cities, but LiveNyte is open and usable wherever you are.
                            </p>
                          </Accordion.Item>

                          <Accordion.Item title="🌐 Can I grow my LiveNyte presence even if my city isn't listed yet?">
                            <p>
                              Yes. LiveNyte offers much more than just event bookings. You can build your profile, sell digital content, attract fans, and grow your brand — no matter where you're located. Early adopters often gain visibility faster as new cities come online.
                            </p>
                          </Accordion.Item>

                          <Accordion.Item title="🎤 Can I still host events or get booked if LiveNyte isn't active in my city yet?">
                            <p>
                              Yes — all of LiveNyte's booking and event tools are available to you. You can host your own events, get booked, and build a verified track record. Even if we're not actively promoting in your area yet, getting started now positions you ahead of the curve.
                            </p>
                          </Accordion.Item>

                          <Accordion.Item title="🚀 Why are you starting with these cities?">
                            <p>
                              We're beginning with a few key cities to build local momentum, activate real-world events, and connect directly with talent and businesses. These areas help us lay the groundwork before expanding outreach to more regions.
                            </p>
                          </Accordion.Item>

                          <Accordion.Item title="🤔 Is LiveNyte still in beta?">
                            <p>
                              Nope — the platform is fully live and ready. We're rolling out live event support city by city, but all features — from bookings to digital content sales — are available now, wherever you are.
                            </p>
                          </Accordion.Item>

                          <Accordion.Item title="💬 Can I help bring LiveNyte to my city?">
                            <p>
                              Yes! The best way to help is to sign up and share LiveNyte with creators and businesses in your area. Cities with strong interest are prioritized for community-building and launch support.
                            </p>
                          </Accordion.Item>

                          <Accordion.Item title="📅 When will you launch in more cities?">
                            <p>
                              We're activating new cities based on signups, demand, and local partnerships. Sign up to be notified when your city goes live — or reach out if you'd like to help bring LiveNyte to your area faster.
                            </p>
                          </Accordion.Item>
                        </Accordion>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Container>
            </section>






            {/* <section className="py-6 bg-white">
            <div className="landingContainer">
            <Row className="row-grid align-items-center">
                <Col className="order-md-2" md="6">
                <Card className="shadow border-0">
                      <CardImg
                          alt={"..."}             
                          src={config.commonUrl + "/Common/musician_preview.mp4"}
                          onError={(e)=>{e.target.onerror = null; e.target.src=musicianVideoFallback}}
                          top
                      />
                </Card>
                </Col>
                <Col className="order-md-1" md="6">
                  <div className="pr-md-5">
                    <h1>Talent & Creators </h1>
                    <h2 className="font-weight-light">A better way to get booked.</h2>
                    <div className="pb-2 special-left-underline-livenyte" style={{paddingTop:"2px"}}></div>                    
                    <p className="mt-2"> LiveNyte provides talent & creators the tools to run their live event bookings & digital presence without agents, managers, or other gatekeepers. 
                    <br/><br/>
                    <b>On LiveNyte, you can be your own manager, get booked at events, plan your own tour, build a website EPK, and sell exclusive content subscriptions.</b>
                    <br/><br/>
                    <h2 className="font-weight-bold">Are you ready to go pro, grow, get more opportunities, and get booked? </h2>
                    </p>
                    <Row className="pt-3">
                    <Col xs={5} sm={5} md={6} lg={6} xl={5}>
                      <Button color="primary" block className={" bg-gradient-livenyte" } size="lg" onClick={this.openSignUp}>
                            Sign up
                        </Button>
                      </Col>
                      <Col xs={5} sm={5} md={6} lg={6} xl={5}>
                      <Link to={{pathname: '/auth/creatorLanding' }}>
                          <Button color="primary" block outline className="" size={"lg"} >Learn more</Button>
                        </Link>
                        </Col>
                      </Row>
                  </div>
                </Col>
              </Row>
            </div>
          </section>
          <section className="py-6 bg-white">
            <div className="landingContainer">
              <Row className="row-grid align-items-center">
              <Col md="6">
        
                <Card className="shadow border-0 px-2">
                    <CardImg
                        alt={"..."}             
                        src={eventOrganizer}
                        top
                    />
                  </Card>
                </Col>
                <Col className="order-md-1" md="6">
                  <div className="pr-md-5">
                    <h1 className="text-left ">
                        Businesses & Event Organizers
                    </h1>
                    <h2 className="font-weight-light">Making event promotion & talent-booking easy. </h2>
                    <div className="pb-2 special-left-underline-tertiary" style={{paddingTop:"2px"}}></div>                    
                    <p className="mt-2"> LiveNyte streamlines events by making the talent-booking, ticket sales, and promotion easy.
                    <br/><br/> 
                    <b>When you host an event and book talent on LiveNyte, we promote your event to local live event fans and your booked talent's fans.</b>
                    <br/><br/>
                    </p>
                    <h2 className="pl-0">Are you ready to plug your events into the live event community?</h2>
                  </div>
                  <Row className="pt-3">
                    <Col xs={5} sm={5} md={6} lg={6} xl={5}>
                      <Button color="tertiary" block className={" bg-gradient-tertiary" } size="lg" onClick={this.openSignUp}>
                            Sign up
                        </Button>
                      </Col>
                      <Col xs={5} sm={5} md={6} lg={6} xl={5}>
                    <Link to={{pathname: '/auth/businessLanding' }}>
                        <Button color="tertiary" block outline className="" size={"lg"} >Learn more</Button>
                      </Link>
                      </Col>
                    </Row>
                </Col>
              </Row>
            </div>
          </section>
          <section className="py-6 bg-white">
            <div className="landingContainer">
              <Row className="row-grid align-items-center">
                <Col className="order-md-2" md="6">
                  <Card className="shadow border-0 px-2">
                      <CardImg
                          alt={"..."}             
                          src={rainbowRoom}
                          top
                      />
                    </Card>
                </Col>
                <Col className="order-md-1" md="6">
                <div className="pr-md-5">
                    <h1 className="text-left ">
                       Fans
                    </h1>
                    <h2 className="font-weight-light">A better fan experience.</h2>
                    <div className="pb-2 special-left-underline-info" style={{paddingTop:"2px"}}></div>                    
                    <p className="mt-2"> LiveNyte fans have a better live event experience from start to finish.
                      <br/><br/>
                      Stay up-to-date with opportunities to engage with your favorite talent & creators. By following them and subscribing to their content, you can help them get booked at events in your area. 
                      <br/><br/>
                      When they get booked, you get notified to check out the event & get tickets. LiveNyte tickets cannot be scalped. 
                      <br/><br/>
                    </p>
                    <h2 className="pl-0">Are you ready to join the live event community?</h2>
                  </div>
                  <Row className="pt-3">
                    <Col xs={5} sm={5} md={6} lg={6} xl={5}>
                    <Button color="info" block className={" bg-gradient-info" } size="lg" onClick={this.openSignUp}>
                            Sign up
                        </Button>
                      </Col>
                      <Col xs={5} sm={5} md={6} lg={6} xl={5}>
                      <Link to={{pathname: '/auth/fanLanding' }}>
                          <Button color="info" block outline className="" size={"lg"} >Learn more</Button>
                        </Link>
                        </Col>
                  </Row>  
                </Col>
              </Row>
            </div>
          </section> */}

            {/* <div className="mt-8 bg-dark"> 
            <section className="section section-lg pt-0 mt--8" style={{transform:"translateY(-96px)"}}>
              <Container>
                <Row className="justify-content-center">
                  <Col lg="12">
                    <Row>
                      <Col lg="4" className={is_md ? "pt-3" : ""}>
                        <Card className="card-lift--hover shadow border-0">
                        <CardImg
                            alt={"..."}             
                            src={config.commonUrl + "/Common/musician_preview.mp4"}
                            onError={(e)=>{e.target.onerror = null; e.target.src=musicianVideoFallback}}
                            top
                        />
                          <CardBody className="py-5">
                            <h4 className="h2 text-primary text-uppercase">
                             Build a great website
                            </h4>
                            <p className="description mt-3">
                            Add photos, videos, and blog to showcase your talent. Your event bookings and subscriptions sold through LiveNyte will automatically be added to your website.
                            </p>
                            <h5 className="surtitle text-dark pt-2 h5-standard">nyte.live/<span className="title text-primary">YOUR_USERNAME</span></h5>
                          </CardBody>
                        </Card>
                      </Col>
                      <Col lg="4" className={is_md ? "pt-3" : ""}>
                        <Card className="card-lift--hover shadow border-0">
                        <CardImg
                            alt={"..."}             
                            src={createExample}
                            style={{objectFit: "cover"}}
                            onError={(e)=>{e.target.onerror = null; e.target.src=noImage}}
                            top
                        />
                          <CardBody className="py-5">
                

                            <h4 className="h2 text-tertiary text-uppercase">
                              Set up your store
                            </h4>

                            <p className="description mt-3 ">
                            Create and sell digital content and subscriptions such as podcasts, newsletters, blogs, music, or for anything else you want. <br/><br/>
                            </p>
                            <h5 className="surtitle text-dark pt-2 h5-standard ">Build your <span className="title text-tertiary">online presence.</span></h5>

                          </CardBody>
                        </Card>
                      </Col>
                      <Col lg="4" className={is_md ? "pt-3" : ""}>
                        <Card className="card-lift--hover shadow border-0">
                        <iframe 
                          className="card-img-top wistia_embed" 
                          style={{aspectRatio:"16/9"}}
                          allowtransparency="true" 
                          title="Wistia video player" 
                          allowFullscreen frameborder="0"
                         scrolling="no" 
                         name="wistia_embed" 
                         src="https://fast.wistia.net/embed/iframe/ba8xnd25gc" 
                         width="auto" 
                         height="auto"
                         
                         ></iframe>
                          <CardBody className="py-5">
                            <h4 className="h2 text-danger text-uppercase">
                            Get booked at live events
                            </h4>
                            <p className="description mt-3">
                            Tell us when and where you're available. And, we'll show you as candidates to book for events.
                            Save time and energy filtering through the noise with our hassle-free event booking system.
                            </p>
                            <h5 className="surtitle text-dark pt-2 h5-standard ">Connect better <span className="title text-danger"> with your fans.</span></h5>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Container>
            </section>
          </div> */}
            {/* <section className="pt-7 pb-6 bg-gradient-livenyte mt--2">
            <Container fluid>
              <Row className="justify-content-center text-center">
                <Col md="9" lg="8">
                  <h1 className="display-3 title text-white" >
                    <span style={{display: "inline"}} className="livenyte-title">LiveNyte</span> 
                  </h1>
                  <h2 className="text-lighter mt-4 font-weight-light">
                    Host events &nbsp;|&nbsp; Book talent &nbsp;|&nbsp; Sell tickets &nbsp;|&nbsp; Promote to local fans 
                  </h2>
                </Col>
              </Row>
            </Container>
          </section> */}

            {/* <section className="py-6 bg-white">
            <Container>
              <Row className="row-grid align-items-center">
          
                <Col md="6">
                  <div className="pr-md-5">
                    <h1>Available on Web & Mobile</h1>
                    <p>
                    Take the <i className="title">LiveNyte</i> experience anywhere you go. 
                    </p>
                    <Row className="pt-2">
                      <Col xs={5} sm={5} md={7} lg={6} xl={5}>
                        <Button color="primary" block className={" bg-gradient-livenyte" } size="lg" onClick={this.openSignUp}>
                            Sign Up
                        </Button>
                      </Col>
                      <Col xs={6} sm={6} md={5} lg={6}>
                        <a href="https://itunes.apple.com/us/app/livenyte/id1378430467?mt=8" 
                              className={"btn-app"}>
                              <img src ={appStore} alt="App Store Button" /> 
                          </a>
                      </Col>
                    </Row>
                  </div>
                </Col>
                <Col md="6">
                  <img
                    alt="..."
                    className="img-fluid"
                    src= {mobileImage} 
                  />
                </Col>
              </Row>
            </Container>
          </section> */}

            {/* <section className="py-6 bg-white">
            <Container>
              <Row className="row-grid align-items-center">
                <Col className="order-md-2" md="6">
                  <img
                    alt="..."
                    className="img-fluid"
                    style={{maxWidth: "400px"}}
                    src={rocket}
                  />
                </Col>
                <Col className="order-md-1" md="6">
                  <div className="pr-md-5">
                    <h1>Why choose us?</h1>
                    <p> We're building LiveNyte into an all-in-one platform and solution for connecting creators, businesses, and their fans. Everything that we have today is just a starting point that we'll build upon and expand from.  
                    </p>
                    <h5 className="surtitle text-tertiary pt-2 h5-standard cursor-pointer" onClick={this.openSignUp} >Let's build that future together. </h5>
                 
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="py-6 bg-white">
            <Container>
              <Row className="row-grid align-items-center">
                <Col md="6">
                  <img
                    alt="..."
                    className="img-fluid"
                    src={lightbulb}
                  />
                </Col>
                <Col md="6">
                  <div className="pr-md-5">
                    <h1>How much does LiveNyte cost?</h1>
                    <p>
                    There are no subscription fees to use LiveNyte. We only collect small fees when transactions go through the platform. These fees help cover the cost for maintaing the platform and building new features. 
                    <h5 className="surtitle text-tertiary pt-2 h5-standard cursor-pointer" onClick={this.openSignUp}> When it works for you, it works for us.</h5>
                  
                    </p>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

          <section className="py-6 bg-white">
            <Container>
              <Row className="row-grid align-items-center">
                <Col className="order-md-2 text-center" md="6">
                  <img
                    alt="..."
                    className="img-fluid rounded-circle "
                    src={livenyteLogo}
                    style={{maxWidth:"360px"}}
                  />
                </Col>
                <Col className="order-md-1" md="6">
                  <div className="pr-md-5">
                    <h1>About us</h1>
                    <Linkify> 
                    <p>
                      We're a team based in the San Franisco Bay Area. We're always looking for passionate people who believe in this future.
                      If you're interested in working with us, feel free to introduce yourself over email to connect@livenyte.com.
                    </p>
                    </Linkify>
                  </div>
                </Col>
              </Row>
            </Container>
          </section> */}
            <Modal
              isOpen={this.state.signUpModal}
              toggle={this.toggleSignUpModal}
              className={`modal-notice register-page ${this.props.is_xs ? "modal-dark" : ""}`}
              contentClassName={this.props.is_xs ? "bg-transparent-carbon" : ""}

              size="lg"
              fade={false}
            >
              <ModalHeader toggle={this.toggleSignUpModal} style={!this.props.is_xs ? { height: "600px" } : { paddingBottom: "0px" }}>
                {!this.props.is_xs &&
                  <Container className={activeContainer}>
                    <AuthFormContainer
                      is_xs={this.props.is_xs}
                      activeContainer={this.state.activeContainer}
                      setActiveContainer={this.setActiveContainer}
                      signupEmailFocus={this.state.signupEmailFocus}
                      signinEmailFocus={this.state.signinEmailFocus}
                      signinPasswordFocus={this.state.signinPasswordFocus}
                      setSigninEmailFocus={this.setSigninEmailFocus}
                      setSignupEmailFocus={this.setSignupEmailFocus}
                      setSigninPasswordFocus={this.setSigninPasswordFocus}
                      email={this.state.email}
                      username={this.state.username}
                      password={this.state.password}
                      handleChange={this.handleChange}
                      enterPressed={this.enterPressed.bind(this)}
                      startEmailRegistration={this.startEmailRegistration}
                      forgotPasswordAlert={this.forgotPasswordAlert}
                      handleSubmit={this.handleSubmit}
                      responseFacebook={this.responseFacebook}
                      responseGoogle={this.responseGoogle}
                      responseApple={this.responseApple}
                      tryAppleLogIn={this.tryAppleLogIn}
                    />
                  </Container>
                }
              </ModalHeader>
              {this.props.is_xs &&
                <ModalBody className="px-0 pt-0">
                  <AuthFormContainerXS
                    mode={this.state.mobileMode}
                    setMode={(m) => this.setState({ mobileMode: m })}
                    is_xs={this.props.is_xs}
                    activeContainer={this.state.activeContainer}
                    setActiveContainer={this.setActiveContainer}
                    signupEmailFocus={this.state.signupEmailFocus}
                    signinEmailFocus={this.state.signinEmailFocus}
                    signinPasswordFocus={this.state.signinPasswordFocus}
                    setSigninEmailFocus={this.setSigninEmailFocus}
                    setSignupEmailFocus={this.setSignupEmailFocus}
                    setSigninPasswordFocus={this.setSigninPasswordFocus}
                    email={this.state.email}
                    username={this.state.username}
                    password={this.state.password}
                    handleChange={this.handleChange}
                    enterPressed={this.enterPressed.bind(this)}
                    startEmailRegistration={this.startEmailRegistration}
                    forgotPasswordAlert={this.forgotPasswordAlert}
                    handleSubmit={this.handleSubmit}
                    responseFacebook={this.responseFacebook}
                    responseGoogle={this.responseGoogle}
                    responseApple={this.responseApple}
                    tryAppleLogIn={this.tryAppleLogIn}
                  />
                </ModalBody>
              }
            </Modal>

            <Modal
              isOpen={this.state.termsPrivacyModal}
              toggle={this.toggleTermsPrivacyModal}
              className="modal-notice"
              size="lg"
              fade={false}
            >
              <ModalHeader toggle={this.toggleTermsPrivacyModal}>
                Terms & Privacy
              </ModalHeader>
              <ModalBody className="text-center">
                <Nav
                  pills
                  className="nav-pills-primary justify-content-center"
                >
                  <NavItem className="cursor-pointer">
                    <NavLink
                      className={this.state.hTabs === "ht1" ? "active" : ""}
                      onClick={() => this.setState({ hTabs: "ht1" })}
                    >
                      Terms of Service
                    </NavLink>
                  </NavItem>
                  <NavItem className="cursor-pointer">
                    <NavLink
                      className={this.state.hTabs === "ht2" ? "active" : ""}
                      onClick={() => this.setState({ hTabs: "ht2" })}
                    >
                      Privacy Policy
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent
                  className="tab-space"
                  activeTab={this.state.hTabs}
                  style={{ marginTop: "15px" }}
                >
                  <TabPane tabId="ht1">
                    <div className="table-full-width table-responsive bg-white">
                      <ResponsiveEmbed src={config.commonUrl + config.termsLocalPath}></ResponsiveEmbed>
                    </div>
                  </TabPane>
                  <TabPane tabId="ht2">
                    <div className="table-full-width table-responsive bg-white">
                      <ResponsiveEmbed src={config.commonUrl + config.privacyLocalPath} ></ResponsiveEmbed>
                    </div>
                  </TabPane>
                </TabContent>
              </ModalBody>
              <ModalFooter>
                <Row>
                  <Col md={8}>
                    <p className="title"> By clicking 'Agree', you agree to LiveNyte's Terms of Service, and have read LiveNyte's Privacy Policy. </p>
                  </Col>
                  <Col md={4}>
                    <div className="float-right">
                      <Button
                        color="danger"
                        className="title"
                        onClick={() => this.completeLogin(false)}
                      >
                        Reject
                      </Button>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <Button
                        color="success"
                        className="title"
                        onClick={() => this.completeLogin(true)}
                      >
                        Agree
                      </Button>
                    </div>
                  </Col>
                </Row>
              </ModalFooter>
            </Modal>
          </div>
          <Row>

          </Row>
          <AuthFooter darkMode={true} />
          {/* <CookieManager/> */}
        </div>
      </>
    );
  }
}

//export default LoginPage;
function mapStateToProps(state) {
  const { authentication, memberInfo, screenSizeData, fanModeData } = state;
  const { loggingIn, loggedIn } = authentication;
  const { info, } = memberInfo;
  const { is_xxs, is_xs, is_sm, is_md, is_lg, is_xl, is_xxl, updateScreenSizeRequest } = screenSizeData;
  const { fanMode } = fanModeData;

  return {
    loggingIn,
    loggedIn,
    info,
    is_xxs, is_xs, is_sm, is_md, is_lg, is_xl, is_xxl, updateScreenSizeRequest,
    fanMode
  };
}

const connectedIndexView = connect(mapStateToProps)(IndexView);
export { connectedIndexView as IndexView }; 